import { useEffect } from 'react'

import { useDataBoxSelector } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  allowancesFilter,
  allowancesFilterSelection,
  subsidyTypeFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const AllowancesFilter = ({ id, pending }: Props) => {
  const subsidyType = useDataBoxSelector(
    subsidyTypeFilterSelection,
    () => subsidyTypeFilterSelection.data,
  )
  const visible = subsidyType.length === 1 && subsidyType[0] === 'personal'

  useEffect(() => {
    if (!visible) allowancesFilterSelection.resetToDefault()
  }, [visible])

  if (!visible) return null
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Тип льгот"
      header="Выбор типа льгот"
      dataBoxData={allowancesFilter}
      dataBoxSelection={allowancesFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      multiple
      disabled={pending}
    />
  )
}
